(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evolved-footer"] && !Shopify.designMode) return;
  try {
    
  /* Footer menus are accordions on mobile and always open on desktop. */
  (function () {
    var mq = window.matchMedia('(min-width: 990px)');
    function sync() {
      document.querySelectorAll('[data-evf-col]').forEach(function (d) {
        if (mq.matches) d.setAttribute('open', '');
        else if (!d.dataset.evfTouched) d.removeAttribute('open');
      });
    }
    document.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('[data-evf-col] > summary');
      if (!s) return;
      if (mq.matches) { e.preventDefault(); return; }
      s.parentElement.dataset.evfTouched = '1';
    });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evolved-header"]) return;
  try {
    
  (function () {
    'use strict';
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var desktop = window.matchMedia('(min-width: 990px)');
    function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function loadMaps(el) {
      if (!el) return;
      qa(el, 'iframe[data-src]').forEach(function (f) { f.src = f.getAttribute('data-src'); f.removeAttribute('data-src'); });
    }
    function firstFocusable(el) {
      return el && el.querySelector('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, [tabindex]:not([tabindex="-1"])');
    }

    /* ---------- Cart count ---------- */
    var cartIconHTML = null;
    function refreshCart() {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          qa(document, '[data-evh-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        })
        .catch(function () {});
    }
    if (window.fetch && !window.__evhFetchPatched) {
      window.__evhFetchPatched = true;
      var nativeFetch = window.fetch;
      window.fetch = function (input) {
        var p = nativeFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/(add|change|update|clear)/.test(url)) {
            p.then(function () { setTimeout(refreshCart, 80); }, function () {});
          }
        } catch (e) {}
        return p;
      };
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
    document.addEventListener('evh:cart-refresh', refreshCart);

    function init(root) {
      if (!root || root.__evh) return;
      root.__evh = true;
      var section = root.closest('.shopify-section') || root.parentElement;
      var overlay = root.querySelector('[data-evh-overlay]');
      var drawer = root.querySelector('[data-evh-drawer]');
      var search = root.querySelector('[data-evh-search]');
      var cartLink = root.querySelector('[data-evh-cart]');
      var state = { panel: null, search: false, drawer: false };
      var openT, closeT, lastPointer = 'mouse';

      function setOverlay() {
        var on = !!(state.panel || state.search || state.drawer);
        if (overlay) overlay.hidden = !on;
        if (on && section) section.classList.remove('evh-section--hidden');
      }

      /* ---------- Desktop panels ---------- */
      function itemFor(id) { return root.querySelector('[data-evh-item="' + id + '"]'); }
      function togglesFor(id) { return qa(root, '[data-evh-toggle="' + id + '"]'); }
      function openPanel(id) {
        clearTimeout(closeT);
        if (state.panel === id) return;
        closePanel();
        closeSearch();
        var p = document.getElementById(id);
        if (!p) return;
        p.hidden = false;
        loadMaps(p);
        togglesFor(id).forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
        var item = itemFor(id);
        if (item) item.classList.add('is-active');
        state.panel = id;
        setOverlay();
      }
      function closePanel(returnFocus) {
        var id = state.panel;
        if (!id) return;
        var p = document.getElementById(id);
        if (p) p.hidden = true;
        togglesFor(id).forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        var item = itemFor(id);
        if (item) item.classList.remove('is-active');
        state.panel = null;
        setOverlay();
        if (returnFocus) { var t = togglesFor(id)[0]; if (t) t.focus(); }
      }
      function scheduleClose() {
        if (!fine.matches) return;
        clearTimeout(openT);
        clearTimeout(closeT);
        closeT = setTimeout(function () { closePanel(); }, 220);
      }

      qa(root, '[data-evh-item]').forEach(function (item) {
        var id = item.getAttribute('data-evh-item');
        item.addEventListener('mouseenter', function () {
          if (!fine.matches || !desktop.matches) return;
          clearTimeout(closeT);
          clearTimeout(openT);
          openT = setTimeout(function () { openPanel(id); }, state.panel ? 0 : 120);
        });
        item.addEventListener('mouseleave', scheduleClose);
      });
      qa(root, '.evh-nav__item:not([data-evh-item])').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          if (!fine.matches) return;
          clearTimeout(openT);
          if (state.panel) { clearTimeout(closeT); closeT = setTimeout(function () { closePanel(); }, 120); }
        });
      });
      qa(root, '[data-evh-panel]').forEach(function (p) {
        p.addEventListener('mouseenter', function () { clearTimeout(closeT); });
        p.addEventListener('mouseleave', scheduleClose);
      });
      qa(root, '[data-evh-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-evh-toggle');
          if (state.panel === id) closePanel(); else openPanel(id);
        });
      });
      root.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);
      root.addEventListener('keydown', function () { lastPointer = 'keyboard'; }, true);
      qa(root, '[data-evh-trigger]').forEach(function (a) {
        var id = a.getAttribute('data-evh-trigger');
        a.addEventListener('click', function (e) {
          /* Touch: first tap opens the panel, second tap follows the link. */
          if ((lastPointer === 'touch' || lastPointer === 'pen') && state.panel !== id) {
            e.preventDefault();
            openPanel(id);
          }
        });
        a.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            openPanel(id);
            var f = firstFocusable(document.getElementById(id));
            if (f) f.focus();
          }
        });
      });

      document.addEventListener('focusin', function (e) {
        if (!state.panel) return;
        var p = document.getElementById(state.panel);
        var item = itemFor(state.panel);
        if ((p && p.contains(e.target)) || (item && item.contains(e.target))) return;
        closePanel();
      });

      /* ---------- Tabs (desktop category rail) ---------- */
      function activateTab(tab, focus) {
        var group = tab.closest('[data-evh-tabs]');
        if (!group) return;
        qa(group, '[data-evh-tab]').forEach(function (t) {
          var on = t === tab;
          if (t.getAttribute('role') === 'tab') {
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
          } else {
            t.classList.toggle('is-active', on);
          }
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
        if (tab.scrollIntoView && group.classList.contains('evh-pills')) {
          var gl = group.getBoundingClientRect(), tl = tab.getBoundingClientRect();
          if (tl.left < gl.left || tl.right > gl.right) group.scrollLeft += tl.left - gl.left - 16;
        }
      }
      qa(root, '[data-evh-tab]').forEach(function (tab) {
        var hoverT;
        var isTab = tab.getAttribute('role') === 'tab';
        /* Real tabs (mobile pills) switch on tap. Category links (desktop) preview on hover or focus and open their page on click. */
        if (isTab) tab.addEventListener('click', function () { activateTab(tab); });
        else tab.addEventListener('focus', function () { activateTab(tab); });
        tab.addEventListener('mouseenter', function () {
          if (!fine.matches) return;
          hoverT = setTimeout(function () { activateTab(tab); }, 70);
        });
        tab.addEventListener('mouseleave', function () { clearTimeout(hoverT); });
        if (isTab) tab.addEventListener('keydown', function (e) {
          var keys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'];
          if (keys.indexOf(e.key) < 0) return;
          e.preventDefault();
          var tabs = qa(tab.closest('[data-evh-tabs]'), '[data-evh-tab]');
          var i = tabs.indexOf(tab);
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') i = (i + 1) % tabs.length;
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') i = 0;
          else i = tabs.length - 1;
          activateTab(tabs[i], true);
        });
      });

      /* ---------- Search ---------- */
      var sInput = search && search.querySelector('.evh-search__input');
      var sResults = search && search.querySelector('[data-evh-search-results]');
      var sDefault = sResults ? sResults.innerHTML : '';
      function openSearch() {
        if (!search) return;
        closePanel();
        if (state.drawer) closeDrawer(true);
        search.hidden = false;
        state.search = true;
        setOverlay();
        qa(root, '[data-evh-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        setTimeout(function () { if (sInput) sInput.focus(); }, 30);
      }
      function closeSearch(returnFocus) {
        if (!search || !state.search) return;
        search.hidden = true;
        state.search = false;
        setOverlay();
        var opener = qa(root, '[data-evh-search-open]');
        opener.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (returnFocus && opener[0]) opener[0].focus();
      }
      qa(root, '[data-evh-search-open]').forEach(function (b) {
        b.addEventListener('click', function () { if (state.search) closeSearch(); else openSearch(); });
      });
      qa(root, '[data-evh-search-close]').forEach(function (b) {
        b.addEventListener('click', function () { closeSearch(true); });
      });

      function cleanTitle(t) { return String(t || '').replace(/^Evolved H2O(™)?:?\s*/i, ''); }
      function money(v) {
        var n = parseFloat(v);
        if (isNaN(n)) return '';
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
        try {
          return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur, minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
        } catch (e) { return '$' + n; }
      }
      function sized(url, w) {
        if (!url) return '';
        return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      }
      function renderResults(data, term) {
        var r = (data && data.resources && data.resources.results) || {};
        /* Skip duplicate offer products whose title ends with " -". */
        var products = (r.products || []).filter(function (p) { return !/\s-\s*$/.test(p.title || ''); }).slice(0, 6);
        var others = [].concat(r.pages || [], r.articles || []).slice(0, 5);
        var page = root.getAttribute('data-search-page') || '/search';
        var allLink = '<a class="evh-textlink evh-search__all" href="' + esc(page) + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last">See all results for “' + esc(term) + '”</a>';
        if (!products.length && !others.length) {
          sResults.innerHTML = '<p class="evh-search__empty">No results for “' + esc(term) + '”. Try “filter” or “refill”.</p>';
          return;
        }
        var html = '<div class="evh-sres">';
        if (products.length) {
          html += '<div><p class="evh-eyebrow">Products</p><ul class="evh-sres__products" role="list">';
          products.forEach(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            html += '<li><a class="evh-sprod" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="evh-sprod__blank"></span>') +
              '<span><span class="evh-sprod__title">' + esc(cleanTitle(p.title)) + '</span>' +
              (p.price ? '<span class="evh-sprod__price">' + esc(money(p.price)) + '</span>' : '') +
              '</span></a></li>';
          });
          html += '</ul></div>';
        }
        if (others.length) {
          html += '<div><p class="evh-eyebrow">Guides and articles</p><ul class="evh-slinks" role="list">';
          others.forEach(function (o) { html += '<li><a href="' + esc(o.url) + '">' + esc(o.title) + '</a></li>'; });
          html += '</ul></div>';
        }
        html += '</div>' + allLink;
        sResults.innerHTML = html;
      }
      if (sInput && sResults) {
        var sTimer, sCtrl, sCache = {};
        var sUrl = root.getAttribute('data-search-url') || '/search/suggest';
        sInput.addEventListener('input', function () {
          var term = sInput.value.trim();
          clearTimeout(sTimer);
          if (term.length < 2) { sResults.innerHTML = sDefault; return; }
          sTimer = setTimeout(function () {
            if (sCache[term]) { renderResults(sCache[term], term); return; }
            if (sCtrl) sCtrl.abort();
            sCtrl = window.AbortController ? new AbortController() : null;
            var url = sUrl + '.json?q=' + encodeURIComponent(term) +
              '&resources[type]=product,page,article&resources[limit]=8&resources[options][unavailable_products]=last';
            fetch(url, sCtrl ? { signal: sCtrl.signal } : {})
              .then(function (r) { return r.json(); })
              .then(function (data) { sCache[term] = data; if (sInput.value.trim() === term) renderResults(data, term); })
              .catch(function () {});
          }, 220);
        });
      }

      /* ---------- Mobile drawer ---------- */
      var burger = root.querySelector('[data-evh-drawer-open]');
      var burgerLabel = burger && burger.querySelector('[data-evh-burger-label]');
      function placeDrawer() {
        var bar = root.querySelector('.evh-bar');
        if (bar) root.style.setProperty('--evh-drawer-top', Math.max(0, Math.round(bar.getBoundingClientRect().bottom)) + 'px');
      }
      function openDrawer() {
        if (!drawer) return;
        closePanel();
        closeSearch();
        if (section) section.classList.remove('evh-section--hidden');
        placeDrawer();
        drawer.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
        state.drawer = true;
        setOverlay();
        document.documentElement.classList.add('evh-lock');
        if (burger) burger.setAttribute('aria-expanded', 'true');
        if (burgerLabel) burgerLabel.textContent = 'Close menu';
        var c = drawer.querySelector('a[href], summary');
        if (c) c.focus({ preventScroll: true });
      }
      function closeDrawer(silent) {
        if (!drawer || !state.drawer) return;
        drawer.classList.remove('is-open');
        state.drawer = false;
        setOverlay();
        document.documentElement.classList.remove('evh-lock');
        if (burger) burger.setAttribute('aria-expanded', 'false');
        if (burgerLabel) burgerLabel.textContent = 'Open menu';
        setTimeout(function () { if (!state.drawer) drawer.hidden = true; }, 240);
        if (!silent && burger) burger.focus();
      }
      if (burger) burger.addEventListener('click', function () { if (state.drawer) closeDrawer(); else openDrawer(); });
      window.addEventListener('resize', function () { if (state.drawer) placeDrawer(); });
      var maccs = qa(root, '[data-evh-macc]');
      qa(root, '.evh-acc').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          loadMaps(d);
          /* Mobile menu cards: keep one open at a time */
          if (d.hasAttribute('data-evh-macc')) maccs.forEach(function (o) { if (o !== d && o.open) o.open = false; });
        });
      });
      qa(root, '[data-evh-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer(); }); });
      if (drawer) {
        var trap = function (e) {
          if (e.key !== 'Tab' || !state.drawer) return;
          /* Keep focus in the menu and its toggle button */
          var f = (burger ? [burger] : []).concat(qa(drawer, 'a[href], button:not([disabled]), input:not([type="hidden"]), summary').filter(function (el) { return el.offsetParent !== null || el === document.activeElement; }));
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        };
        drawer.addEventListener('keydown', trap);
        if (burger) burger.addEventListener('keydown', trap);
      }

      /* ---------- Shared close handlers ---------- */
      if (overlay) overlay.addEventListener('click', function () { closePanel(); closeSearch(); closeDrawer(true); });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (state.drawer) closeDrawer();
        else if (state.search) closeSearch(true);
        else if (state.panel) closePanel(true);
      });
      var onBreakpoint = function () { closePanel(); closeSearch(); closeDrawer(true); };
      if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);

      /* ---------- Sticky: hide on scroll down, show on scroll up ---------- */
      var mode = root.getAttribute('data-sticky');
      if (mode === 'scroll_up' && section) {
        var lastY = window.scrollY, ticking = false;
        window.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var y = window.scrollY;
            var busy = state.panel || state.search || state.drawer;
            if (!busy) {
              if (y > lastY + 6 && y > 240) section.classList.add('evh-section--hidden');
              else if (y < lastY - 6 || y < 120) section.classList.remove('evh-section--hidden');
            }
            lastY = y;
            ticking = false;
          });
        }, { passive: true });
      }

      /* ---------- Announcement rotation (mobile) ---------- */
      var msgs = qa(root, '[data-evh-ann-msg]');
      if (msgs.length > 1 && !root.querySelector('[data-evh-ann-inline]')) {
        var ai = 0, paused = false;
        var ann = root.querySelector('[data-evh-ann]');
        if (ann) {
          ann.addEventListener('mouseenter', function () { paused = true; });
          ann.addEventListener('mouseleave', function () { paused = false; });
        }
        setInterval(function () {
          if (paused || desktop.matches || document.hidden) return;
          msgs[ai].classList.remove('is-active');
          ai = (ai + 1) % msgs.length;
          msgs[ai].classList.add('is-active');
        }, 4000);
      }

      /* ---------- Cart link: keep our icon if another script rewrites it ---------- */
      if (cartLink && window.MutationObserver) {
        cartIconHTML = cartLink.innerHTML;
        new MutationObserver(function () {
          if (!cartLink.querySelector('[data-evh-cart-icon]')) {
            cartLink.innerHTML = cartIconHTML;
            refreshCart();
          }
        }).observe(cartLink, { childList: true });
      }

      /* ---------- Contact form: reopen the panel after sending ---------- */
      if (location.hash === '#EvhContactForm' && desktop.matches) {
        var form = document.getElementById('EvhContactForm');
        var panel = form && form.closest('[data-evh-panel]');
        if (panel) openPanel(panel.id);
      }

      root.__evhApi = { openPanel: openPanel, closePanel: closePanel };
    }

    function boot() { qa(document, '[data-evh]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

    /* Theme editor support */
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-evh]');
      if (r) init(r);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var r = e.target.closest && e.target.closest('[data-evh]');
      var id = e.target.getAttribute && e.target.getAttribute('data-evh-item');
      if (r && r.__evhApi && id) r.__evhApi.openPanel(id);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var r = e.target.closest && e.target.closest('[data-evh]');
      if (r && r.__evhApi) r.__evhApi.closePanel();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
